import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { MEDIA } from "../data/brand";

export default function Gallery() {
  const [active, setActive] = useState(null);

  return (
    <section
      id="galeria"
      data-testid="gallery-section"
      className="relative scroll-mt-24 py-20 md:py-28"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div className="max-w-xl">
            <span className="text-xs font-medium uppercase tracking-[0.2em] text-[#1E3A8A]">
              Galería
            </span>
            <h2 className="mt-3 font-display text-3xl font-medium tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
              Conoce nuestras instalaciones
            </h2>
          </div>
          <p className="max-w-md text-base leading-relaxed text-slate-600">
            Una clínica pensada para la comodidad de tu mascota y la
            tranquilidad de tu familia.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {MEDIA.gallery.map((g, i) => (
            <motion.button
              key={g.url}
              data-testid={`gallery-item-${i}`}
              onClick={() => setActive(g)}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.06 }}
              className="group relative aspect-[4/3] overflow-hidden rounded-2xl text-left"
            >
              <img
                src={g.url}
                alt={g.caption}
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/70 via-slate-900/0 to-slate-900/0 opacity-90" />
              <div className="absolute bottom-3 left-4 right-4">
                <span className="rounded-full bg-white/90 px-3 py-1 text-xs font-medium text-slate-800 backdrop-blur">
                  {g.caption}
                </span>
              </div>
            </motion.button>
          ))}
        </div>
      </div>

      <AnimatePresence>
        {active && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[60] flex items-center justify-center bg-slate-900/80 p-4 backdrop-blur"
            onClick={() => setActive(null)}
          >
            <motion.div
              initial={{ scale: 0.95, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.95, opacity: 0 }}
              className="relative max-w-4xl"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                aria-label="Cerrar"
                data-testid="gallery-close-btn"
                onClick={() => setActive(null)}
                className="absolute -top-3 -right-3 grid h-10 w-10 place-items-center rounded-full bg-white text-slate-700 shadow-lg"
              >
                <X className="h-5 w-5" />
              </button>
              <img
                src={active.url}
                alt={active.caption}
                className="max-h-[85vh] w-full rounded-2xl object-contain"
              />
              <p className="mt-3 text-center text-sm text-white/90">
                {active.caption}
              </p>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
